module.exports = __webpack_public_path__ + "img/clock-nine-thirty.e274d5d7.svg";